import { render, staticRenderFns } from "./BeyondEconomicalRepairCityDashboard.vue?vue&type=template&id=2e8da6e7&"
import script from "./BeyondEconomicalRepairCityDashboard.vue?vue&type=script&lang=js&"
export * from "./BeyondEconomicalRepairCityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BeyondEconomicalRepairCityDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports